// extracted by mini-css-extract-plugin
module.exports = {"pokeCard":"CardCatItens_pokeCard__37lZe","cardTitle":"CardCatItens_cardTitle__3R7Km","imgCarregando":"CardCatItens_imgCarregando__10HvJ"};